// extracted by mini-css-extract-plugin
export default {"container":"Robot_container__FCWax","panel":"Robot_panel__cPLqD","wrapper":"Robot_wrapper__HjdyC","info":"Robot_info__NXzlS","unit":"Robot_unit__gY2OM"};